import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
export type StaffRoleProfileFragment = { usersCount: number, sampleUsers: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> };


export type StaffRoleProfileFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const StaffRoleProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment StaffRoleProfile on RoleProfileType {
  usersCount
  sampleUsers {
    ...User
  }
}
    `;